import React, { Component } from 'react';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
window.state = false;
export class KioskIdelScreen extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.state = {
      open: false,
      time: 5
    };
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
  }
  startTimer() {
    this.setState({
      time: this.state.time
    });
    this.timer = setInterval(() => {
      this.setState({
        time: this.state.time - 1
      });
      if (this.state.time === 0) {
        this.stopTimer();
        this.handleBack();
      }
    }, 1000);
  }
  stopTimer() {
    this.resetTimer();
    clearInterval(this.timer);
    this.idleTimer = null;
  }
  resetTimer() {
    this.setState({ time: 5 });
  }
  handleClickOpen = () => {
    this.setState({ open: true });
    window.state = this.state.open;
    setTimeout(() => {
      if (window.state) {
        this.props.push('/');
        this.props.push('/');
      }
    }, 10000);
  };
  handleClose = () => {
    this.setState({ open: false });
    this.stopTimer();
    window.state = false;
  };
  handleBack = () => {
    this.props.push('/');
    this.props.push('/');
  };

  render() {
    return (
      <div>
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={parseInt(process.env.REACT_APP_IDEAL_DEBOUNCE, 10)}
          timeout={parseInt(process.env.REACT_APP_IDEAL_TIMEOUT, 10)}
        />
        <Dialog
          fullWidth={true}
          width={'lg'}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div
            style={{
              background: 'linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)'
            }}
          >
            <DialogContent>
              <DialogContentText
                style={{ color: '#387371', textAlign: 'center' }}
                id="alert-dialog-description"
              >
                Are you still there ({this.state.time}) ?
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Button onClick={this.handleClose} style={{ color: '#387371' }}>
                Yes
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    );
  }
  _onAction(e) {
    // console.log('user did something', e);
  }
  _onActive(e) {
    // console.log('user is active', e);
  }
  _onIdle(e) {
    this.handleClickOpen();
    this.startTimer();
  }
}

export default connect(
  null,
  { push }
)(KioskIdelScreen);
